import { render, staticRenderFns } from "./BillPayments.vue?vue&type=template&id=b96b41f2&scoped=true"
import script from "./BillPayments.vue?vue&type=script&lang=js"
export * from "./BillPayments.vue?vue&type=script&lang=js"
import style0 from "./BillPayments.vue?vue&type=style&index=0&id=b96b41f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96b41f2",
  null
  
)

export default component.exports